import { PrizeItem } from "@/components/Index/PrizeItem"
import { Card } from "@/components/ui/card"
import { CardHeader } from "@/components/CardHeader"
import bolt from "@/assets/funnel-bolt.svg";
import { ShineEffect } from "@/components/ShineEffect"
import type { Prize } from "@/components/Index/OtherAvailableCards"
import moneymint from "@/assets/moneymint.png";
import millionairemaker from "@/assets/MillionaireMaker.png";
import crazy99s from "@/assets/Crazy99s.png";
import triplecashblast from "@/assets/TripleCashBlast.png"
import paydaybonanza from "@/assets/paydaybonanza.png"



const prizesConst: Prize[] = [
    {
        name: "The Money Mint",
        amount: "$550,000",
        cost: "$25",
        textColor: "text-green-500",
        bgColor: "bg-green-500",
        borderColor: "border-green-500",
        src: moneymint
    },
    {
        name: "Millionaire Maker",
        amount: "$1,265,000",
        cost: "$50",
        textColor: "text-blue-400",
        bgColor: "bg-blue-400",
        borderColor: "border-blue-400",
        src: millionairemaker
    },
    {
        name: "Crazy 99s",
        amount: "$99,000",
        cost: "$10",
        textColor: "text-purple-500",
        bgColor: "bg-purple-500",
        borderColor: "border-purple-500",
        src: crazy99s
    },
    {
        name: "Triple Cash Blast",
        amount: "$850,000",
        cost: "$40",
        textColor: "text-yellow-400",
        bgColor: "bg-yellow-400",
        borderColor: "border-yellow-400",
        src: triplecashblast
    },
    {
        name: "10X Payday",
        amount: "$485,000",
        cost: "$15",
        textColor: "text-red-500",
        bgColor: "bg-red-500",
        borderColor: "border-red-500",
        src: paydaybonanza,
    },
];

export function AllCardsModal() {
    return (
        <Card className="w-11/12 rounded-lg overflow-hidden shadow-md bg-white border-0">
            <CardHeader title="All Available Cards" />
            <ShineEffect>
            <div className="bg-green text-white p-3 flex justify-center items-center space-x-3">
                    <h1 className="text-xl font-bold">Huge prizes 24/7</h1>
                    <div className="bg-white px-2 py-0.5 rounded-sm flex items-center space-x-1">
                        <img src={bolt} className='h-4' alt='instant'/>
                        <span className="text-md text-gold font-semibold">Instant</span>
                    </div>
                </div>
            </ShineEffect>
            <div className="overflow-y-auto p-1 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
                {prizesConst.map((prize) => (
                    <PrizeItem 
                        key={`${prize.name}-available`} 
                        prize={prize}
                    />
                ))}
            </div>
        </Card>
    )
}